module.exports = __webpack_public_path__ + "static/media/CyberLogovo_3_t.8cf602bf.jpg";